import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Input, Button, Label } from '@windmill/react-ui';
import { useHistory, useParams } from 'react-router-dom';
import { SERVER } from '../constant/constant';
import { toast } from 'react-toastify';

const ResetPass = () => {
    const history = useHistory();
    const { token } = useParams(); // Get token from the URL
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState('');

    // Redirect to login if token is not available
    useEffect(() => {
        if (!token) {
            history.push('/login');
        }
    }, [token, history]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        setSuccess('');

        if (newPassword !== confirmPassword) {
            setError('Passwords do not match');
            return;
        }

        setLoading(true);

        const data = await axios.post(
            `${SERVER}/v1/hospital/auth/reset-password/${token}`,
            {
                newPassword,
                confirmPassword,
            }
        ).then(res => {
            if (res.data) {
                toast.success(res.data?.message)
                setTimeout(() => {
                    history.push('/login');
                }, 1500);
            }
        }).catch((err) => {
            setError('Failed to reset password');
            toast.error(err?.response?.data?.message)

        }).finally(() => {
            setLoading(false);
        })


    };

    return (
        <div className="flex items-center justify-center min-h-screen bg-gray-100">
            <form
                onSubmit={handleSubmit}
                className="p-6 bg-white shadow-md rounded-lg w-96 space-y-4"
            >
                <h2 className="text-xl font-bold text-center mb-4">Reset Password</h2>

                <Label>
                    <span>New Password</span>
                    <Input
                        type="password"
                        className="mt-1"
                        placeholder="Enter new password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                        required
                    />
                </Label>

                <Label>
                    <span>Confirm Password</span>
                    <Input
                        type="password"
                        className="mt-1"
                        placeholder="Confirm new password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        required
                    />
                </Label>

                {error && <p className="text-red-500 text-sm">{error}</p>}
                {success && <p className="text-green-500 text-sm">{success}</p>}

                <Button type="submit" block className="mt-4" disabled={loading}>
                    {loading ? 'Resetting...' : 'Reset Password'}
                </Button>
            </form>
        </div>
    );
};

export default ResetPass;
